import * as React from 'react';

import {
  Avatar,
  AvatarBadge,
  AvatarFallback,
  AvatarGroup,
  AvatarGroupCount,
  AvatarImage,
} from './components/ui/avatar.js';

export function DimeAvatar({ ...props }: Readonly<React.ComponentProps<typeof Avatar>>) {
  return <Avatar {...props} />;
}

export function DimeAvatarImage({ ...props }: Readonly<React.ComponentProps<typeof AvatarImage>>) {
  return <AvatarImage {...props} />;
}

export function DimeAvatarFallback({
  ...props
}: Readonly<React.ComponentProps<typeof AvatarFallback>>) {
  return <AvatarFallback {...props} />;
}

export function DimeAvatarBadge({ ...props }: Readonly<React.ComponentProps<typeof AvatarBadge>>) {
  return <AvatarBadge {...props} />;
}

export function DimeAvatarGroup({ ...props }: Readonly<React.ComponentProps<typeof AvatarGroup>>) {
  return <AvatarGroup {...props} />;
}

export function DimeAvatarGroupCount({
  ...props
}: Readonly<React.ComponentProps<typeof AvatarGroupCount>>) {
  return <AvatarGroupCount {...props} />;
}
